import { Person, PersonData } from "@/sources/kicker-amateur/types";
import IconDefaultPlayer from "@/assets/icon/default-player.png";
import Link from "next/link";
import { pwaMemberDetailPath } from "@/utils/urlHelper";
import Image from "../Image";

interface PersonDisplayProps {
  person: Person | PersonData;
  className?: string;
  functionsList?: boolean
}

export function PersonDisplay({ person, className, functionsList=false}: PersonDisplayProps) {

  function functionText() {
    return (
      Array.isArray(person.Function)
        ? person.Function?.map(
          (func) =>
            `${func.Organization?.Name}${func.FunctionType?.Name === "Ohne Position"
              ? ""
              : ` (${func.FunctionType?.Name})`
            }`
        ).join(", ")
        : `${person.Function?.Organization?.Name}${person.Function?.FunctionType?.Name === "Ohne Position"
          ? ""
          : ` (${person.Function?.FunctionType?.Name})`
        }`
    )
  }

  return (
    <div className={`flex gap-2 ${functionsList ? "items-start" : "items-center"} ${className ?? ""}`}>
      <div className={`rounded-full overflow-hidden ${functionsList ? "mt-1" : ""}`}>
        <Image
          className="w-10 h-10 object-cover"
          src={`/api/image/person/${person.Id}`}
          alt={`${person.FirstName} ${person.LastName}`}
          fallback={IconDefaultPlayer.src}
        />
      </div>
      <div className="flex-1 ">
        <div className="font-semibold">{`${person.FirstName} ${person.LastName}`}</div>
        { functionsList && functionText().split(", ").length > 1 ?
          <ul className="pl-4">
            {functionText().split(", ").map((func, index) => (
              <li key={index} className="list-disc" title={func}>
                {func}
              </li>
            ))}
          </ul>
          :
            <div className="text-ellipsis line-clamp-1" title={functionText()}>
              {functionText()}
            </div>
          }
      </div>
    </div>
  );
}

interface ClubProfileProps {
  persons: Person[] | PersonData[] | Person | PersonData;
  onRequestClose?: () => void
}
export function ClubProfile({ onRequestClose, persons }: ClubProfileProps) {
  return (
    <>
      {/* <div className="font-semibold py-4 inline-flex justify-center w-full">

        Vereinsmitglied
      </div> */}
      <div className="divide-y divide-solid divide-gray-150 border-t border-gray-150 mt-4">
        {Array.isArray(persons) ? (
          persons.map((person) => (
            <Link key={`Link-${person.Id}`} href={pwaMemberDetailPath(person.Id!)} onClick={onRequestClose}>
              <PersonDisplay key={person.Id} person={person} className="py-4" />
            </Link>
          ))
        ) : (
          <PersonDisplay person={persons} />
        )}
      </div>
    </>
  );
}
